import videojs from "video.js"
import ahoy from "ahoy.js";

/* Setup tracking */
ahoy.configure({
  cookies: false,
  visitsUrl: "/pipe/visits",
  eventsUrl: "/pipe/events"
});

const Button = videojs.getComponent('Button');
class UnmuteButton extends Button {
  buildCSSClass() {
    return 'vjs-big-unmute-button';
  }

  createEl(tag, props = {}, attributes = {}) {
    tag = 'button';

    props = Object.assign({
      innerHTML: '<svg viewBox="0 0 237 237"><polygon fill="white" points="88 107 65 107 65 131 89 131 112 154 112 84"></polygon><g fill="none" stroke="white" stroke-width="10" stroke-linecap="round"><path class="volume__small-wave" d="M 142 86 C 151 107 151 130 142 151"></path><path class="volume__large-wave" d="M 165 74 C 178 97 178 140 165 163"></path></g></svg>',
      className: this.buildCSSClass()
    }, props);

    const el = Button.prototype.createEl.call(this, tag, props, attributes);

    this.createControlTextEl(el);

    return el;
  }

  handleClick() {
    triggerUnmute();
  }
};

const setupMuteButton = (player, stats) => {
  const unmuteButton = new UnmuteButton(player);

  const triggerUnmute = () => {
    player.muted(false);
    player.currentTime(0);
    player.play();
    player.removeClass("vjs-unmute-button-visible");
    unmuteButton.hide();

    if (!stats.played) {
      const percentage = Math.floor(player.currentTime() / player.duration() * 100);
      !stats.selfEmbed && ahoy.track("Pressed play", { video_id: stats.videoId, percentage });
      stats.played = true;
    }
  }

  player.addChild(unmuteButton);
  player.addClass("vjs-unmute-button-visible");

  player.on('volumechange', () => {
    if (player.hasClass("vjs-unmute-button-visible")) {
      triggerUnmute();
    }
  });

  player.bigPlayButton.on('click', () => {
    if (player.hasClass("vjs-unmute-button-visible")) {
      triggerUnmute();
    }
  });

  player.on('click', () => {
    if (player.hasClass("vjs-unmute-button-visible")) {
      triggerUnmute();
    }
  });
}

const setupLoop = (player, start, end) => {
  if (start < 0) {
    start = 0;
  }

  if (end > player.duration()) {
    end = player.duration();
  }

  player.currentTime(start);
  try {
    player.play();
  } catch (e) {
    player.removeClass("vjs-seeking-preview-loop");
  }

  /* Sometimes the video will go to a point just before the loop (rounding), so allow a small margin on the start position check. */
  const startMargin = 0.005;

  player.on('timeupdate', () => {
    if (player.hasClass("vjs-unmute-button-visible")) {
      const currentTime = player.currentTime();

      if (currentTime > end) {
        player.currentTime(start);
      }

      if (currentTime < (start - startMargin)) {
        player.currentTime(start);
      }
    }
  });
}

const setupPreviewLoop = (player, start, end, stats) => {
  /* Show the black poster until we've started playing the preview loop */
  player.addClass("vjs-seeking-preview-loop");
  player.on("playing", () => player.removeClass("vjs-seeking-preview-loop"));

  /* Setup the mute button, and run the loop. */
  setupMuteButton(player, stats);
  player.on("loadeddata", () => setupLoop(player, start, end));
}

export { setupPreviewLoop }
